import React from "react";
import styled, { useTheme } from "styled-components";
import ReactApexChart from "react-apexcharts";

export const DonutChart = () => {
  const chartOptions = {
    chart: {
      type: "donut",
    },
    labels: ["Simple", "Duo"],
    colors: ["#ca0606", "#bcbabc"],
    plotOptions: {
      pie: {
        donut: {
          size: "45%",
        },
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  };
  const series = [44, 66];

  return (
    <ChartColumnCard>
      <ChartTitle>Combos</ChartTitle>
      <ContainerCharts>
        <ReactApexChart
          //   className="flex flex-auto items-center justify-center w-full h-full"
          options={chartOptions}
          series={series}
          type="donut"
        />
      </ContainerCharts>
    </ChartColumnCard>
  );
};

const ChartColumnCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 35%;
  align-self: start;
  border-radius: 10px;
  margin-bottom: 60px;
  @media (max-width: 1200px) {
    align-self: center;
    width: 75%;
    margin-bottom: 0px;
  }
`;
const ContainerCharts = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px;
  background-color: #ffffff;
`;
const ChartTitle = styled.h2`
  margin: 10px 0px 0px 15px;
  font-size: 1.2em;
  color: #333;
  text-align: left;
  font-family: "Roboto", sans-serif;
  text-align: center;
`;
